import { useMutation } from 'react-query';
import { authFetch } from '../../CommonUtils/authFetch';
import { urlWithParams } from '../../CommonUtils/urlWithParams';
import { EntityDTO, ProviderType } from '../DocumentVault.meta';

interface FolderPath {
  folderPath: string;
  path: string;
  providerType: ProviderType;
  currentYear: number | null;
}

interface CreateFolderParams {
  folderData: FolderPath;
  clientId: string;
}

const createFolder = ({ folderData, clientId }: CreateFolderParams): Promise<EntityDTO> => {
  return authFetch(
    urlWithParams('/Consumer/DocumentVault/CreateFolder', {
      clientId,
      ...folderData,
    }),
    {
      method: 'POST',
    },
  );
};

export const useCreateFolderMutation = () => {
  return useMutation(createFolder);
};
